/* MOVTECH — orszaghivo-szam valaszto telefon mezokhoz.
   Markup: snippets/movtech-phone-code.liquid + a `.movtech-phone` kontener.

   A valaszto NEM kulon urlapmezo: a hivoszam magaba a telefonszamba kerul bele,
   igy JS nelkul is hasznalhato marad az urlap (a latogato beirja a teljes szamot).

   A fajl tobb szekciobol is behivodhat, ezert az egesz egy egyszeri-futas orzo
   mogott van, es a kezelok a documenten ulnek (a kosar-drawer es a quickview
   utolag is tolthet be urlapot). */
(function () {
  if (window.__movtechPhoneReady) {
    return;
  }
  window.__movtechPhoneReady = true;

  var ROOT = '.movtech-phone';
  var FIELD = '.movtech-phone input[type="tel"]';

  /* --- Bevitel-takaritas -----------------------------------------------
     A mezo `pattern`-je csak szamjegyet, `+`-t, szokozt, kotojelet, zarojelet
     es perjelet enged. Gepelve ez nem gond, DE a BEILLESZTETT szam gyakran
     lathatatlan vagy „szep" karaktereket hoz magaval: iOS-en a nevjegybol
     masolt szamban iranyjelzo van (U+202A…U+202C), a Wordbol masoltban
     gondolatjel (–), a weboldalrol masoltban nem torheto szokoz.
     Ilyenkor a bongeszo csak annyit mond: „Kerjuk, tartsa magat a kivant
     formatumhoz" — a latogato meg azt hiszi, a +36-os alakot nem fogadjuk el.

     Ezert: gepeleskor csendben egysegesitjuk ezeket a karaktereket,
     beillesztéskor pedig a maradek tiltott karaktert is kiszedjuk (pl.
     a „Tel.: " elotagot). Betut gepelve NEM torlunk, ott a hibauzenet szol. */
  var INVISIBLE = /[\u00AD\u200B-\u200F\u202A-\u202E\u2060-\u2064\u2066-\u2069\uFEFF]/g;
  var FULLWIDTH = /[\uFF10-\uFF19\uFF0B]/g;
  var DASHES = /[\u2010-\u2015\u2043\u2212\uFE58\uFE63\uFF0D]/g;
  var SPACES = /[\t\u00A0\u1680\u2000-\u200A\u202F\u205F\u3000]/g;
  var SEPARATORS = /[.,\u00B7\u2022]/g;
  var NOT_ALLOWED = /[^0-9+\s()\/-]/g;
  var HIBA = 'Csak számjegy, +, szóköz, kötőjel és zárójel lehet benne. Például: +36 20 123 4567';

  function normalize(value) {
    return value
      .replace(INVISIBLE, '')
      .replace(FULLWIDTH, function (ch) {
        return ch === '\uFF0B' ? '+' : String.fromCharCode(ch.charCodeAt(0) - 0xfee0);
      })
      .replace(DASHES, '-')
      .replace(SPACES, ' ')
      .replace(SEPARATORS, ' ');
  }

  function cleanPasted(value) {
    return normalize(value)
      .replace(NOT_ALLOWED, '')
      .replace(/ {2,}/g, ' ')
      .replace(/^ +/, '');
  }

  // Az ertek atirasa a kurzort a vegere dobna, ezert kiszamoljuk, hova kerul:
  // a kurzor utani resz hossza nem valtozik a takaritastol.
  function applyValue(input, next) {
    if (next === input.value) {
      return;
    }

    var pos = null;
    try {
      pos = input.selectionStart;
    } catch (e) {
      pos = null;
    }

    var head = pos === null ? null : next.length - (input.value.length - pos);
    input.value = next;

    if (head !== null && head >= 0 && head <= next.length && input.setSelectionRange) {
      try {
        input.setSelectionRange(head, head);
      } catch (e) {
        /* tel mezon elvileg megy, de ne bukjon el rajta */
      }
    }
  }

  // A bongeszo alap uzenete nem mondja meg, mi a baj. Sajat szoveget adunk,
  // de csak amig tenyleg tiltott karakter van a mezoben.
  function refreshMessage(input) {
    if (!input.setCustomValidity) {
      return;
    }

    input.setCustomValidity('');

    if (input.value && input.validity && input.validity.patternMismatch) {
      input.setCustomValidity(HIBA);
    }
  }

  function getSelect(el) {
    var root = el.closest(ROOT);
    return root ? root.querySelector('.movtech-phone__code') : null;
  }

  function getInput(el) {
    var root = el.closest(ROOT);
    return root ? root.querySelector('input[type="tel"]') : null;
  }

  // Hosszabb hivoszam eloszor, kulonben a +3 elfogna a +36-ot.
  function dialCodes(select) {
    return Array.prototype.map
      .call(select.options, function (option) {
        return option.value;
      })
      .sort(function (a, b) {
        return b.length - a.length;
      });
  }

  function matchCode(value, codes) {
    for (var i = 0; i < codes.length; i++) {
      if (value.indexOf(codes[i]) === 0) {
        return codes[i];
      }
    }
    return null;
  }

  function withoutCode(value, codes) {
    var trimmed = value.trim();
    var code = matchCode(trimmed, codes);
    return code ? trimmed.slice(code.length).trim() : trimmed;
  }

  function notifyChanged(input) {
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  // Orszag valasztasa: a meglevo szam ele kerul az uj hivoszam.
  // Ures mezot szandekosan nem toltunk fel, hogy ne tunjon kitoltottnek.
  document.addEventListener('change', function (event) {
    var target = event.target;
    if (!target.closest || !target.closest('.movtech-phone__code')) {
      return;
    }

    var select = target.closest('.movtech-phone__code');
    var input = getInput(select);
    if (!input) {
      return;
    }

    var rest = withoutCode(input.value, dialCodes(select));
    input.value = rest ? select.value + ' ' + rest : '';
    if (rest) {
      notifyChanged(input);
    }
  });

  // Ha a latogato maga ir be nemzetkozi elotagot, a valaszto kovesse.
  document.addEventListener('input', function (event) {
    var input = event.target;
    if (!input.matches || !input.matches(FIELD)) {
      return;
    }

    var pasted = event.inputType === 'insertFromPaste' || event.inputType === 'insertFromDrop';
    applyValue(input, pasted ? cleanPasted(input.value) : normalize(input.value));
    refreshMessage(input);

    var select = getSelect(input);
    var value = input.value.trim();
    if (!select || value.charAt(0) !== '+') {
      return;
    }

    var code = matchCode(value, dialCodes(select));
    if (code) {
      select.value = code;
    }
  });

  // Kilepeskor a helyi szam ele bekerul a valasztott hivoszam, a belfoldi
  // elotag (magyar `06`, mashol egy vezeto `0`) levagasaval.
  document.addEventListener(
    'focusout',
    function (event) {
      var input = event.target;
      if (!input.matches || !input.matches(FIELD)) {
        return;
      }

      // A jelszokezelo/autofill utolag is beirhat, ezert itt is takaritunk.
      applyValue(input, normalize(input.value));

      var select = getSelect(input);
      var value = input.value.trim();

      // Elotagot csak valodi helyi szamhoz teszunk. Ha van benne `+` (akar
      // zarojelben: „(+36) 20/123-4567"), akkor mar nemzetkozi alak. Ha meg
      // tiltott karakter van benne, a hibauzenet a dolga, nem az atirasa.
      var nemzetkozi = value.indexOf('+') !== -1;
      var tiltott = /[^0-9\s()\/-]/.test(value);
      if (!select || !value || nemzetkozi || tiltott) {
        refreshMessage(input);
        return;
      }

      if (select.value === '+36' && value.indexOf('06') === 0) {
        value = value.slice(2);
      } else if (value.charAt(0) === '0') {
        value = value.slice(1);
      }

      input.value = (select.value + ' ' + value.trim()).trim();
      refreshMessage(input);
      notifyChanged(input);
    },
    true
  );

  // Betolteskor a mar kitoltott szamhoz igazitjuk a valasztot (pl. bejelentkezett
  // vasarlo mentett telefonszama).
  function syncExisting(scope) {
    var roots = (scope || document).querySelectorAll(ROOT);
    Array.prototype.forEach.call(roots, function (root) {
      var select = root.querySelector('.movtech-phone__code');
      var input = root.querySelector('input[type="tel"]');
      if (!select || !input) {
        return;
      }

      applyValue(input, normalize(input.value));

      var value = input.value.trim();
      if (value.charAt(0) !== '+') {
        return;
      }

      var code = matchCode(value, dialCodes(select));
      if (code) {
        select.value = code;
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      syncExisting();
    });
  } else {
    syncExisting();
  }

  // A tema-szerkeszto ujrarendereli a szekciokat.
  document.addEventListener('shopify:section:load', function (event) {
    syncExisting(event.target);
  });
})();
